import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Flame } from 'lucide-react';
export function TopFlashBar() {
  const [timeLeft, setTimeLeft] = useState(29 * 60 + 47);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => setTimeLeft(t => Math.max(0, t - 1)), 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <AnimatePresence data-id="element-347">
      <motion.div initial={{
      y: -50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-[#0a1628] via-[#162544] to-[#0a1628] text-[#faf7f2] shadow-md border-b border-[var(--accent)]/20" data-id="element-348">
        <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent pointer-events-none" animate={{
        x: ['-100%', '200%']
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-349" />
        <div className="max-w-7xl mx-auto px-3 py-1 sm:py-1.5 flex items-center justify-center gap-1.5 sm:gap-4 relative z-10 text-[10px] sm:text-xs font-medium" data-id="element-350">
          <div className="flex items-center gap-1 flex-shrink-0" data-id="element-351">
            <Flame className="w-3 h-3 text-yellow-300 fill-yellow-300 flex-shrink-0" data-id="element-352" />
            <span className="uppercase tracking-wider font-bold text-yellow-200" data-id="element-353">
              <span className="hidden sm:inline" data-id="element-354">OFERTA ESPECIAL</span>
              <span className="sm:hidden" data-id="element-355">OFERTA</span>
            </span>
          </div>
          <span className="hidden sm:inline opacity-40" data-id="element-356">—</span>
          <span className="italic opacity-90 flex-shrink-0" data-id="element-357">
            <span className="hidden sm:inline" data-id="element-358">Solo $6.99 · Termina en:</span>
            <span className="sm:hidden" data-id="element-359">$6.99 ·</span>
          </span>
          <div className="flex items-center gap-0.5 font-mono font-bold bg-black/30 px-1.5 py-0.5 rounded text-yellow-200 flex-shrink-0" data-id="element-360">
            <span data-id="element-361">{pad(minutes)}</span>
            <span className="animate-pulse" data-id="element-362">:</span>
            <span data-id="element-363">{pad(seconds)}</span>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>;
}